import ResetPasswordForm from "components/Organisms/login/forms/resetPassword/resetPasswordForm";

export default function ResetPasswordTemplate() {
  return (
    <>
      <ResetPasswordForm />
    </>
  );
}
